import React, { useState, useEffect } from 'react';
import { Sidebar } from '../Sidebar/Sidebar';
import { Header } from '../Header/Header';
import { useLocation } from 'react-router-dom';

interface LayoutProps {
  children: React.ReactNode;
  pageTitle?: string;
}

export const Layout: React.FC<LayoutProps> = ({
  children,
  pageTitle = 'Dashboard'
}) => {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const location = useLocation();

  // Automatically collapse sidebar on mobile devices
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setIsSidebarCollapsed(true);
      } else {
        setIsSidebarCollapsed(false);
      }
    };

    // Set initial state
    handleResize();

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div className="flex h-screen w-screen overflow-hidden bg-[#F4F4F6] text-slate-800 font-sans antialiased">

      {/* Sidebar */}
      <Sidebar
        currentPath={location.pathname}
        isCollapsed={isSidebarCollapsed}
        onToggleCollapse={() => setIsSidebarCollapsed(!isSidebarCollapsed)}
      />

      {/* Main Content Wrapper */}
      <div className="flex-1 flex flex-col h-full overflow-hidden">

        {/* Header */}
        <Header title={pageTitle} />

        {/* Scrollable View Area */}
        <main className="flex-1 overflow-y-auto p-3 sm:p-6 md:p-8 bg-[#EFEFEF] hide-scrollbar">
          <div className="max-w-[1600px] mx-auto animate-fadeIn">
            {children}
          </div>
        </main>

      </div>

    </div>
  );
};
export default Layout;
